<ng-container *ngIf="cms">
  <!-- <ng-container *ngIf="finalKey.length != 0"> -->
  <div id="viewCmsStuiod" style="width:960px" class="float-left" [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}"
    [style.zIndex]="cmsList.length + 1">
    <div class="pageTitle">
      {{title}}
      <i class="material-icons pullfloat-right" (click)="closeView()">close</i>
    </div>
    <div class="col-md-12">
      <img src="images/cms-icons/cms-temp-page.png" style="width: 100%;">
      <!-- <p [innerHtml]=cms.innerHtml>
        </p> -->
      <!-- <div class="row">
                                <div class="col-md-4">
                                    <ng-container *ngFor="let item of finalKey">
                                        <p [innerHtml]="item">
                                        </p>
                                    </ng-container>
                                </div>
                                <div class="col-md-6">
                                    <ng-container *ngFor="let values of finalValue">
                                        <span [innerHtml]="values"></span>
                                    </ng-container>
                                </div>
                            </div> -->
    </div>
  </div>
  <!-- </ng-container> -->
  <!-- <app-cms-child [sideToggle]="slideToggle"></app-cms-child> -->

  <!--side navigation-->

  <!--NAVIGATION 3-->
  <!-- <div class="ax-cms-view-nav">
    <ng-container *ngFor="let cml of cmsList">
      <div class="btn-group1-1 ax-nav-btn-group" role="group" aria-label="Basic example">
        <button class="btn ax-nav-btn-parent">
          <div>
            {{cml.title}}
          </div>
        </button>
      </div>
    </ng-container>
  </div> -->


  <ng-container *ngFor="let cml of cmsList; let i = index">
    <div class="ax-ver-nav" [style.background-color]="getBackgroundColor(i)" [style.zIndex]="cmsList.length - i"
      (click)="viewNavigation(i)" [class.hide]="viewNavIndex != null">
      <h6>{{cml.title}}</h6>
    </div>
    <div class="float-left" *ngIf="viewNavIndex == i" style="width: 906px; background: #fff; height: 100%;border-left:1px solid #dee2e6">
      <div class="pageTitle">
        {{cml.title}}
        <i class="material-icons pullfloat-right" (click)="viewNavIndex = null;openViewStudio()">close</i>
      </div>
      <div class="col-md-12" style="height: 100%">
        <div [innerHtml]="cml?.innerHtml | sanitizeHtml" (click)="clickEvent($event)"></div>
      </div>
    </div>
  </ng-container>

</ng-container>

<!-- <p  [innerHtml]=keysCms> -->
<!-- </p> -->
<!-- <span>{{keysCms}}</span> -->

<!--side view key-->
<!-- <ng-container *ngFor="let item of collection" > -->
<!-- <div class="ax-sideview-toggle"> -->

<!-- </div> -->
<!-- </ng-container> -->
<!--side view key ened-->
